import { GridColumnConfig } from '../../models/gridCoumnConfig';

export const projectRequestColumns: GridColumnConfig[] = [
  {
    title: 'Project Name',
    field: 'projectName',
    filter: 'text',
    // width: '220',
    searchable: true,
  },
  {
    title: 'Description',
    field: 'projectDescription',
    filter: 'text',
    // width: '220',
    searchable: true,
  },
  {
    title: 'Project Code',
    field: 'projectCode',
    filter: 'text',
    // width: '220',
    searchable: true,
  },
  {
    title: 'Address',
    field: 'address',
    filter: 'text',
    searchable: true,
    // width: '150',
  },
  {
    title: 'Status',
    field: 'reqStatus',
    filter: 'text',
    // width: '180',
    searchable: true,
  }
];
